import React from 'react';
import { compose } from 'redux';
import { connectMediaStore } from '../../../_hocs/withOwnReduxStore';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import ArrowLeftIcon from '../../../../Icons/ArrowLeft';
import withCurrentGallection from './../../../_hocs/withCurrentGallection';
import withSearch from './../../../_hocs/withSearch';
import { initGallectionStream } from '../../../actions';
import s from './MobileHeaderBackButton.scss';
var enhance = compose(withSearch, withCurrentGallection, connectMediaStore(null, { initGallectionStream: initGallectionStream }));
export var MobileHeaderBackButton = function (_a) {
    var currentFolderId = _a.currentFolderId, unsetCurrentFolderId = _a.unsetCurrentFolderId, searchQuery = _a.searchQuery, unsetSearchQuery = _a.unsetSearchQuery, unsetSearchInput = _a.unsetSearchInput, initGallectionStreamProp = _a.initGallectionStream, className = _a.className;
    var t = useTranslation().t;
    if (!currentFolderId && !searchQuery) {
        return null;
    }
    return (React.createElement("button", { className: classnames(s['root'], className), onClick: function () {
            return [
                unsetCurrentFolderId,
                unsetSearchQuery,
                unsetSearchInput,
                initGallectionStreamProp,
            ].forEach(function (fn) { return fn(); });
        } },
        React.createElement(ArrowLeftIcon, { className: s['icon'] }),
        t('mediapopup.back')));
};
MobileHeaderBackButton.displayName = 'MobileHeaderBackButton';
export default enhance(MobileHeaderBackButton);
//# sourceMappingURL=MobileHeaderBackButton.connected.js.map